import React from 'react';
import {useFormContext, useWatch} from 'react-hook-form';
import Translate from '@src/components/Translate/Translate';
import {formatPrice} from '@src/helpers/formatters/prices/formatPrice';
import {IPurchaseModel} from '@src/@interfaces/models/Purchase/IPurchaseModel';

export function TableCaption() {
    const {control} = useFormContext<IPurchaseModel>();
    const values = useWatch({control, name: 'materials'});

    const price = Math.floor((values ?? []).reduce<number>((res, item) => {
        if (item.price) {
            return res + item.price * (item.quantity ?? 0);
        }

        return res;
    }, 0));

    return <Translate
            message="PurchasesShow.fields.materials.caption-message"
            replace={{
                price: price,
                formattedPrice: formatPrice(price)
            }}
            tag="caption"
            className="px-2"
    />;
}
